module.exports = __webpack_public_path__ + "static/media/gorra (6).4c87a923.png";